/**
 * SubscriptionStatus Enum - Frontend only
 * Status states for subscriptions calculated on the client side
 */
export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  EXPIRING_SOON = 'EXPIRING_SOON',
  UNKNOWN = 'UNKNOWN',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  PROGRAMMED = 'PROGRAMMED',
  /** Solo aplica al status general del socio: nunca ha tenido cortesía ni suscripción. */
  NONE = 'NONE',
  SESSION = 'SESSION',
}

/**
 * CourtesyStatus Enum - Frontend only
 * Status states for courtesies calculated on the client side
 */
export enum CourtesyStatus {
  ACTIVE = 'ACTIVE',
  EXPIRING_SOON = 'EXPIRING_SOON',
  UNKNOWN = 'UNKNOWN',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
}
